import { CHAT_ENTITY } from '../../constants/entity'
import { getApi, postApi } from '../../utils/api'

export function createChat(data) {
  return postApi({ data, endpoint: 'api/chatroom/' })
}

export function getChatProfileWidgetsInfo({ options, uuid }) {
  return getApi({
    endpoint: `idwell-api/api/v3/${CHAT_ENTITY.single}/${CHAT_ENTITY.plural}/${uuid}/widgets-info/`,
    options,
  })
}

export function performChatMassAction(data) {
  return postApi({
    data,
    endpoint: `idwell-api/api/v3/${CHAT_ENTITY.single}/${CHAT_ENTITY.plural}/mass-action/`,
  })
}
